module.exports = __webpack_public_path__ + "img/juxueBg.113d551e.png";